import React, { Fragment, useState, useEffect } from "react";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import MsgDataService from "../../../services/MsgService";
import CustomLoader from "../../customLoader/CustomLoader";
import "./StudentMessage.css";

const CannedModal = ({ open, close, handleCannedMessageSelect }) => {
  const [cannedMessagedata, setCannedMessageData] = useState([]);
  const [page] = useState(1);
  const [loading, setLoading] = useState(false);
  const [user] = useState(
    localStorage.getItem("user") && JSON.parse(localStorage.getItem("user"))
  );

  const getCannedMessage = () => {
    setLoading(true);
    let obj = {
      school_id: user?.school_id,
      page: page,
    };
    MsgDataService.getCannedMsg(obj)
      .then((data) => {
        const list = (data?.data?.result || []).filter(
          (item) => item?.messages?.en?.subject
        );
        setCannedMessageData(list);
      })
      .catch(() => {
        setCannedMessageData([]);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (open) getCannedMessage();
  }, [open]);

  return (
    <Fragment>
      <Modal
        className="school-it-canned-modal"
        isOpen={open}
        toggle={close}
        centered
        size="lg"
      >
        <ModalHeader toggle={close} className="school-it-canned-header">
          Select Message
        </ModalHeader>
        <ModalBody className="school-it-canned-body">
          {loading ? (
            <div className="school-it-canned-loading">
              <CustomLoader />
            </div>
          ) : cannedMessagedata?.length > 0 ? (
            <div className="school-it-canned-list">
              {cannedMessagedata.map((item, index) => (
                <button
                  type="button"
                  key={item?.id || index}
                  onClick={() => handleCannedMessageSelect(item)}
                  className="school-it-canned-item"
                >
                  <p className="school-it-canned-subject">
                    {item?.messages?.en?.subject}
                  </p>
                  <p className="school-it-canned-text">
                    {item?.messages?.en?.body}
                  </p>
                </button>
              ))}
            </div>
          ) : (
            <div className="school-it-canned-empty">
              No scheduled messages available
            </div>
          )}
        </ModalBody>
        <ModalFooter className="school-it-canned-footer">
          <button
            type="button"
            className="school-it-canned-cancel"
            onClick={close}
          >
            Cancel
          </button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
};

export default CannedModal;
